import { Controller } from '@hotwired/stimulus'
import { subscribeToProjectLiveCollectChannel } from '../channels/project_live_collect_channel.js'

export default class SubscriptionController extends Controller {
  static targets = ['maxAmountMessageContainer', 'amount', 'broadcastContainer'];
  static values = {
    maxAmount: Number,
  }

  connect() {}

  checkMaxAmount() {
    if (this.amountTarget.value > this.maxAmountValue) {
      this.maxAmountMessageContainerTarget.classList.remove('d-none');
    } else {
      this.maxAmountMessageContainerTarget.classList.add('d-none');
    }
  }

  broadcastContainerTargetConnected() {
    subscribeToProjectLiveCollectChannel($(this.broadcastContainerTarget));
  }

  closeOffcanvas() {
    if (this.amountTarget.value > 0) {
      bootstrap.Offcanvas.getOrCreateInstance(this.element).hide();
    }
  }
}
